import "./AddressesComponent.scss";
import "./AddressesComponentMobile.scss";
import AddressesModal from "./AddressesModal/AddressesModal";
import React, { useEffect, useState } from "react";
import NewAddress from "./AddressesModal/ModalContent/NewAddress/NewAddress";
import EditAddress from "./AddressesModal/ModalContent/EditAddress/EditAddress";
import { useAppContext } from "../../../../../Components/AppProvider";

function AddressesComponent() {
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const [userId, setUserId] = useState("");
  const [addresses, setAddresses] = useState([]);
  const { hasNewAddress, setHasNewAddress } = useAppContext();

  const fetchAddresses = () => {
    if (!userId) return;
    fetch(`${process.env.REACT_APP_BASE_URL}api/address/get-addresses`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cpId: userId }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddresses(data);
        setHasNewAddress((p) => !p);
      })
      .catch((err) => console.error("Error fetching addresses:", err));
  };
  // Fetch user profile to get CP_ID
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.CP_ID) setUserId(data.CP_ID);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchAddresses();
  }, [userId]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this address?"))
      return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/address/delete/${id}`,
        {
          method: "DELETE",
        }
      );
      const data = await res.json();
      if (res.ok) {
        fetchAddresses(); // refresh list after deletion
      } else {
        alert(data.error || "Failed to delete address");
      }
    } catch (err) {
      console.error("Error deleting address:", err);
      alert("Failed to delete address");
    }
  };
  const handleSetDefault = async (caId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}address/set-default`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cpId: userId, caId }),
        }
      );
      const data = await res.json();
      if (res.ok) {
        fetchAddresses(); // refresh the list to show the new default
      } else {
        alert(data.error || "Failed to set default address");
      }
    } catch (err) {
      console.error("Error setting default address:", err);
      alert("Failed to set default address");
    }
  };
  const handleEditAddress = (addr) => {
    setEditAddress(addr); // store address to edit
    setModalOpen(true); // open modal
  };

  if (loading) return <p>Loading profile...</p>;

  return (
    <>
      <div className="is-ac-container">
        <div className="is-ac-header">
          <div className="is-ac-header-wrapper">MY ADDRESSES</div>
          <div className="is-ac-edit-button-wrapper">
            <button onClick={() => setModalOpen(true)}>ADD NEW ADDRESS</button>
          </div>
        </div>

        <div className="is-ac-addresses">
          {addresses.length === 0 ? (
            <p>No addresses found.</p>
          ) : (
            addresses.map((addr, idx) => (
              <div className="is-ac-addr-items" key={idx}>
                <div className="is-ac-addr-info">
                  <div className="is-ac-addr-detials">
                    <p>
                      <span>{addr.CA_Fullname}</span> | {addr.CA_Contactnumber}
                    </p>
                    <p>
                      {addr.CA_StreetAddress}, {addr.CA_Barangay},{" "}
                      {addr.CA_CityMunicipality}, {addr.CA_DistrictProvince},{" "}
                      {addr.CA_Region} {addr.CA_PostalCode || ""}
                    </p>
                    {addr.CA_Landmark && <p>Landmark: {addr.CA_Landmark}</p>}
                  </div>
                  {addr.CA_IsDefault === 1 && (
                    <div className="is-ac-def-addr">DEFAULT ADDRESS</div>
                  )}
                </div>

                <div className="is-ac-addr-action">
                  <button onClick={() => handleEditAddress(addr)}>EDIT</button>
                  <button onClick={() => handleDelete(addr.CA_ID)}>
                    DELETE
                  </button>
                  {addr.CA_IsDefault !== 1 && (
                    <button
                      className="btn-black"
                      onClick={() => handleSetDefault(addr.CA_ID)}
                    >
                      SET AS DEFAULT
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <AddressesModal
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
          setEditAddress(null); // clear edit state
        }}
        title={editAddress ? "Edit Address" : "New Address"}
      >
        {editAddress ? (
          <EditAddress
            onClose={() => {
              setModalOpen(false);
              setEditAddress(null); // reset so modal doesn't stay open
            }}
            user_id={userId}
            editAddress={editAddress} // Pass the address to edit
            onAddressEdited={fetchAddresses}
          />
        ) : (
          <NewAddress
            onClose={() => setModalOpen(false)}
            user_id={userId}
            onAddressAdded={fetchAddresses} // fixed typo
            hasAddressAlready={addresses.length === 0 ? false : true}
          />
        )}
      </AddressesModal>
    </>
  );
}

export default AddressesComponent;
